if (!customElements.get('vv-hero-video')) {
  customElements.define('vv-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const showPoster = () => this.removeAttribute('data-playing');
      const showVideo = () => {
        if (!this.video.paused && !this.video.error && this.video.readyState >= 2) {
          this.setAttribute('data-playing', '');
        }
      };

      this.video.addEventListener('playing', showVideo, options);
      this.video.addEventListener('error', showPoster, options);
      this.video.addEventListener('emptied', showPoster, options);
      this.video.addEventListener('pause', showPoster, options);

      // Playback may already have started before the deferred script loads.
      if (!this.video.paused && this.video.readyState >= 2) showVideo();
      this.video.muted = true;
      this.video.play().catch(showPoster);
    }

    disconnectedCallback() {
      this.events?.abort();
    }
  });
}
